import { useEffect } from 'react'
import { trackPage } from 'utils/analyticsV2'

export const usePageLoad = (name?: string) => {
  useEffect(() => {
    const _ = async () => {
      let pageName = name
      pageName ||= document.body.dataset.pageName
      pageName ||= document.location.pathname.replace(/^[/]/, '').replace(/[_/]/g, '-')
      await trackPage(pageName)
    }
    _()
  }, [name])
}
